import { t } from "i18next";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFetch } from "../../../../hooks/useFetch";
import { useAppStore } from "../../../../stores/RootStore";
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogTitle } from "../../../../ui/AlertDialog/AlertDialog";
import { Button } from "../../../../ui/Button";

type Props = {
  id: string;
  isDeleteOpen: boolean;
  closeModal: Function;
};

const EquipmentDelete = ({ id, isDeleteOpen, closeModal }: Props) => {
  const navigate = useNavigate()
  const equipments = useAppStore((store) => store.equipments)!;
  const setEquipments = useAppStore((store) => store.setEquipments);

  const [
    {
      response: deleteResponse,
      isLoading: deleteIsLoading,
      error: deleteError,
    },
    doFetchItemDelete,
  ] = useFetch(`/directories/equipment_items/${id}`);

  const deleteEquipmentItemFromStore = () => {
    setEquipments(equipments?.filter((equipment) => equipment.id != id)!);
  };

  

  useEffect(() => {
    if (deleteResponse && isDeleteOpen) {
      deleteEquipmentItemFromStore();
      navigate("..", { relative: "path" });
      closeModal();
    }
  }, [deleteResponse]);

  const onDelete = () => {
    doFetchItemDelete({method: "DELETE"});
  };

  const openStateChange = () => {
    if (isDeleteOpen) closeModal();
  };

  return (
    <AlertDialog open={isDeleteOpen} onOpenChange={openStateChange}>
      <AlertDialogContent style={{ maxWidth: 450 }}>
        <AlertDialogTitle>Удалить оборудование</AlertDialogTitle>
        <AlertDialogDescription>
          Вы уверены, что хотите удалить оборудование?
        </AlertDialogDescription>

        <div className="flex justify-between mt-4">
          <Button variant={"destructive"} size={"md"} className="px-3" onClick={onDelete}>{t("delete")}</Button>
          <AlertDialogCancel className="h-8">{t("cancel")}</AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default EquipmentDelete;
  